import DynamicForm from './DynamicForm';

export default DynamicForm;
